import React from "react";
import { Info } from "lucide-react";
import { DISCLAIMER } from "../lib/api";

export const DisclaimerBanner = ({ variant = "soft" }) => {
  if (variant === "inline") {
    return (
      <div data-testid="disclaimer-inline" className="flex items-start gap-2 rounded-2xl border border-slate-200 bg-[#F0F4F8] px-4 py-3 text-sm text-slate-600">
        <Info className="w-4 h-4 mt-0.5 shrink-0 text-slate-500" strokeWidth={1.75} />
        <p className="leading-relaxed">{DISCLAIMER}</p>
      </div>
    );
  }
  return (
    <div data-testid="disclaimer-banner" className="w-full bg-[#F0F4F8] border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-2 text-xs sm:text-sm text-slate-600">
        <Info className="w-4 h-4 shrink-0 text-slate-500" strokeWidth={1.75} />
        <p className="leading-snug">{DISCLAIMER}</p>
      </div>
    </div>
  );
};
